'use client';

import { useEffect, useState } from 'react';

import AdSense from './AdSense';
import GoogleTagManager from './GoogleTagManager';
import YandexAdsScript from './YandexAdsScript';

export default function AdsAndAnalyticsLoader() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const run = () => setReady(true);

    // сначала ждём, пока страница станет интерактивной / отрисуется
    if (typeof window !== 'undefined') {
      if ('requestIdleCallback' in window) {
        (window as any).requestIdleCallback(run);
      } else {
        const t = setTimeout(run, 3000); // запас, чтобы уж точно не лезть в LCP
        return () => clearTimeout(t);
      }
    }
  }, []);

  if (!ready) return null;

  return (
    <>
      {/* здесь уже можно выключить inactive, когда решишь включать AdSense */}
      <AdSense inactive={false} />
      <GoogleTagManager />
      <YandexAdsScript />
    </>
  );
}
